import { Button, Col, Descriptions, Modal, Row, Space, message, Spin } from "antd";
import { AudioOutlined, VideoCameraOutlined, SoundFilled, CheckCircleOutlined,
         CloseCircleOutlined, LoadingOutlined} from "@ant-design/icons";
import { useEffect, useRef, useState, memo } from "react";
import "./AppointmentJoinModal.scss";
import utils from "utils";
import { useHistory } from "react-router-dom";
import { AudioInputTest, testAudioInputDevice } from "@twilio/rtc-diagnostics";
import api from "utils/api";
import { CONSTANTS } from "utils/constant";
import { WarningIcon, VideoPreview } from "Common/ReactIcons";
import LinkButton from "Components/LinkButton";
import CommonButton from "Components/CommonButton";
import Icons from "Common/Icons";
import { useTranslation, Trans } from "react-i18next";
import { PRIMARY_LANG, LANG_STYLD_EXT, TS_STYLD_COMPS } from "Common/constant";
import { useSelector } from 'react-redux';

const Video = require("twilio-video");
const { runPreflight } = require("twilio-video");

let audioInputTest;
// let recordingURL = "";
const audioEl = new Audio();
let interval = null;
let isAudioListenStarted = false;
let isAudioButtonClicked = false;
let preflightTest = null;

const AppointmentJoinModal = ({
  setShowJoinModal,
  apptDetail,
  role,
  redirectPath,
  doctor_last_name,
  patient_last_name
}) => {
  const history = useHistory();

  const [countdown, setCountdown] = useState(6);

  const [testCount, setTestCount] = useState(0);

  const localVideoTrackRef = useRef(null);

  const [listening, setListening] = useState(false);

  const [previewing, setPreviewing] = useState(false);

  const [playingAudio, setPlayingAudio] = useState(false);

  const [testResults, setTestResults] = useState([]);

  const [disableActions, setDisableActions] = useState(false);

  const [disableVideo, setDisableVideo] = useState(false);

  const [disableAudio, setDisableAudio] = useState(false);

  const [audioVerified, setAudio] = useState(false);
  const [videoVerified, setVideo] = useState(false);

  const includePrimeLang = useSelector((state) => state.loginReducer.includePrimeLang);
  const { t, i18n } = useTranslation();
  const tgtLang = includePrimeLang
      ? i18n.language + "_" + PRIMARY_LANG
      : i18n.language;
  const tgtLangST = includePrimeLang ? tgtLang + LANG_STYLD_EXT : tgtLang;

  const handleAudio = () => {
    if(!isAudioButtonClicked){
      isAudioButtonClicked = true;
    if (listening && audioInputTest) {
      audioInputTest.stop();
      isAudioButtonClicked = false;
    } else {
      // setDisableAudio(true);
      // setTestResults((prevState) => ({
      //   ...prevState,
      //   audio: {
      //     status: "loading",
      //     label: "Recording Audio",
      //   },
      // }));
      // setCountdown(6);
      // interval = setInterval(() => {
      //   setCountdown((prevCountdown) => prevCountdown - 1);
      // }, 1000);
      // setTestCount((prevTstCount) => prevTstCount + 1);
      isAudioListenStarted = false;
      audioInputTest = testAudioInputDevice({ enableRecording: true });
      audioInputTest.on(AudioInputTest.Events.Volume, (Volume) => {
        if (!isAudioListenStarted) {
          setListening(true);
        }   
        if (!isAudioListenStarted) {
          isAudioListenStarted = true;
          setTestResults((prevState) => ({
            ...prevState,
            audio: {
              status: "loading",
              label: "Recording Audio",
            },
          }));
          setCountdown(6);
          interval = setInterval(() => {
            setCountdown((prevCountdown) => prevCountdown - 1);
          }, 1000);
          setTestCount((prevTstCount) => prevTstCount + 1);
        }
      });

      audioInputTest.on(AudioInputTest.Events.Error, (error) => {
        setTestResults((prevState) => ({
          ...prevState,
          audio: {
            status: "error",
            label: "Audio Error",
          },
        }));
        audioInputTest.stop(true);
        setListening(false);
        isAudioButtonClicked = false;
        setDisableAudio(false);
        setTestCount((prevCountdown) => prevCountdown - 1);
      });

      audioInputTest.on(AudioInputTest.Events.End, (report) => {
        if (report.errors.length == 0 && !audioEl.muted) {
          audioEl.src = report.recordingUrl;
          setPlayingAudio(true);
          setTestResults((prevState) => ({
            ...prevState,
            audio: {
              status: "loading",
              label: "Playing Audio",
            },
          }));
          audioEl.play();
          audioEl.addEventListener("ended", function () {
            setPlayingAudio(false);
            setTestResults((prevState) => ({
              ...prevState,
              audio: {
                status: "success",
                label: "Audio Tested",
              },
            }));
          });
          setListening(false);
          setDisableAudio(false);
          isAudioButtonClicked = false;
        }

        // // Revoke the url if no longer needed
        // URL.revokeObjectURL(report.recordingUrl);
      });
    }
  }
  };

  const playAudio = () => {
    setTestCount((prevTstCount) => prevTstCount - 1);
    audioEl.muted = false;
    audioInputTest.stop();
    setListening(false);
    isAudioButtonClicked = false;
    setDisableAudio(false);
  };

  const handleVideo = () => {
    if (previewing && localVideoTrackRef.current) {
      localVideoTrackRef.current.stop();
      setPreviewing(!previewing);
    } else {
      setDisableVideo(true);
      setTestResults((prevState) => ({
        ...prevState,
        video: {
          status: "loading",
          label: "Checking Video",
        },
      }));
      if (!localVideoTrackRef.current) {
        // Video.createLocalVideoTrack({
        //   width: 548,
        //   height: 224,
        // })
        setTestCount((prevTstCount) => prevTstCount + 1);
        Video.createLocalVideoTrack()
          .then(function (videoTrack) {
            localVideoTrackRef.current = videoTrack;
            const container = document.getElementById("video-container");
            container.appendChild(videoTrack.attach());
            setPreviewing(!previewing);
            setTestResults((prevState) => ({
              ...prevState,
              video: {
                status: "success",
                label: "Video Tested",
              },
            }));
            setDisableVideo(false);
            setTestCount((prevTstCount) => prevTstCount - 1);
          })
          .catch((error) => {
            setTestResults((prevState) => ({
              ...prevState,
              video: {
                status: "error",
                label: "Video Error",
              },
            }));
            setDisableVideo(false);
            setTestCount((prevTstCount) => prevTstCount - 1);
          });
      } else {
        localVideoTrackRef.current.restart();
        setTestResults((prevState) => ({
          ...prevState,
          video: {
            status: "success",
            label: "Video Tested",
          },
        }));
        setPreviewing(!previewing);
        setDisableVideo(false);
      }
    }
  };

  const handleRedirection = (resp_app, token, patientOffSet) => {
    if (role == "doctor") {
      let path = `/doctor/video-consultation`;
      history.push({
        pathname: path,
        state: {
          identity: resp_app.appointment_doctor_user_id,
          rmt_prtcp_id: resp_app.appointment_patient_user_id,
          localUserName: resp_app.appointment_doctor,
          localUserLastName: resp_app.doctor_last_name,
          remoteUserName: resp_app.appointment_patient,
          remoteUserLastName: resp_app.appointment_patient_last_name,
          doc_api_id: resp_app.appointment_doctor_id,
          pat_identity: resp_app.appointment_patient_id,
          gender: resp_app?.appointment_patient_gender,
          user_type: resp_app?.appointment_patient_user_type,
          is_doctor: true,
          token: token,
          roomName: resp_app.appointment_id,
          type: role,
          age: resp_app?.age,
          localusr: resp_app.doctor_salutation + ". " + resp_app.appointment_doctor,
          remoteusr: resp_app.appointment_patient,
          appointment_date: resp_app.appointment_date,
          appointment_utc_date_time: resp_app.appointment_utc_date_time,
          appointment_patient_is_evaluated:
            resp_app.appointment_patient_is_evaluated,
          is_multiple_session: resp_app.is_multiple_session,
          patient_off_set: patientOffSet,
        },
      });
    } else if (role == "patient") {
      let path = `/logged-in-user/video-consultation`;
      history.push({
        pathname: path,
        state: {
          identity: resp_app.appointment_patient_user_id,
          rmt_prtcp_id: resp_app.appointment_doctor_user_id,
          localUserName: resp_app.appointment_patient,
          localUserLastName: resp_app.patient_last_name,
          remoteUserName: resp_app.appointment_doctor,
          remoteUserLastName: resp_app.doctor_last_name,
          is_doctor: false,
          token: token,
          roomName: resp_app.appointment_id,
          type: role,
          localusr: resp_app.appointment_patient,
          remoteusr:
            resp_app.doctor_salutation + ". " + resp_app.appointment_doctor,
          appointment_date: resp_app.appointment_date,
          appointment_utc_date_time: resp_app.appointment_utc_date_time,
        },
      });
    }
  };

  const handleTestConnection = (testConn) => {
    let data = {
      app_id:
        role == "doctor"
          ? apptDetail?.appointment_id
          : apptDetail?.app_id || apptDetail?.appointment_id,
      type: role,
    };
    setDisableActions(true);
    api
      .get_joinNow_appointment_details(data)
      .then((response) => {
      if(response?.data?.status == 200){
        let resp_twilio = response?.data?.data?.twilio;
        let resp_app = response?.data?.data?.appointment;
        let patientOffSet =
          response?.data?.data.appointment.patient_timezone_offset_in_min;
        if (
          ((resp_twilio.doctor_token == null ||
            resp_twilio.doctor_token == "undefined" ||
            resp_twilio.doctor_token == "") &&
            role == "doctor") ||
          ((resp_twilio.patient_token == null ||
            resp_twilio.patient_token == "undefined" ||
            resp_twilio.patient_token == "") &&
            role == "patient")
        ) {
          let msg =
           t(CONSTANTS.VIDEO_CONSULTATION_JOINED, {lng: tgtLang}) +
            resp_app.appointment_time_difference;
          // message.warning(msg, ErrorDuration);
          message.open({
            content:<><div className="warning-appointment-join" style={{display:"flex",alignItems:"center"}}><WarningIcon />{msg}</div></>,
            duration:ErrorDuration
          });
          setDisableActions(false);
        } else {
          let token =
            role == "doctor"
              ? response?.data?.data?.twilio?.doctor_token
              : response?.data?.data?.twilio?.patient_token;

          if (testConn) {
            setTestResults((prevState) => ({
              ...prevState,
              connection: {
                status: "loading",
                label: "Checking Connectivity",
              },
            }));

            preflightTest = runPreflight(token);
            // preflightTest.on("progress", (progress) => {
            //   console.log("Test inprogress", progress);
            // });
            preflightTest.on("failed", (error, report) => {
              let data = {
                app_id:
                  role == "doctor"
                    ? apptDetail?.appointment_id
                    : apptDetail?.app_id || apptDetail?.appointment_id,
                type: role,
                status: "Failure",
              };
              setTestResults((prevState) => ({
                ...prevState,
                connection: {
                  status: "error",
                  label: "Connection Error",
                },
              }));
              setDisableActions(false);
              api
                .submit_preflight_error(data)
                .then((res) => {})
                .catch((err) => {});
            });

            preflightTest.on("completed", (report) => {
              setDisableActions(false);
              setTestResults((prevState) => ({
                ...prevState,
                connection: {
                  status: "success",
                  label: "Connection Successful",
                },
              }));
              handleRedirection(resp_app, token, patientOffSet);
            });
          } else {
            setTestResults((prevState) => ({
              ...prevState,
              connection: {
                status: "loading",
                label: "Connecting...",
              },
            }));
            handleRedirection(resp_app, token, patientOffSet);
          }
        }
      }else{
        message.error(response?.data?.message, ErrorDuration);
        setDisableActions(false);
      }
      })
      .catch((err) => {
        setTestResults((prevState) => ({
          ...prevState,
          connection: {
            status: "error",
            label: "Error Occured",
          },
        }));
        setDisableActions(false);
      });
  };

  const handleCancel = () => {
    if (redirectPath) {
      history.replace({
        pathname: redirectPath,
        state: { loadDashboard: true },
      });
    } else {
      setShowJoinModal(false);
    }
  };

  useEffect(() => {
    if (countdown == 0) {
      clearInterval(interval);
      playAudio();
    }
  }, [countdown]);

  useEffect(() => {
    return () => {
      clearInterval(interval);
      isAudioButtonClicked = false;
      if (preflightTest) {
        preflightTest.stop();
        preflightTest = null;
      }
      if (localVideoTrackRef.current) {
        localVideoTrackRef.current.stop();
      }
      // Revoke the recorded audio url
      audioEl.pause();
      URL.revokeObjectURL(audioEl.src);
      if (audioInputTest) {
        audioEl.muted = true;
        audioInputTest.stop();
      }
    };
  }, []);

  return (
    <>
      <Modal className="appointment-join-modal" open centered title={<><div className="title"><Trans components={TS_STYLD_COMPS}>{t(CONSTANTS.APPOINTMENT_DETAILS, {lng: tgtLangST})}</Trans></div></>} closable footer={null} width={600} onCancel={() => handleCancel()}>
        <div className="appointment-join-modal-container">
          <div className="inner-container">
          <Space direction="vertical" size="large">
            <Row gutter={8} justify="start">

              <div className="appointment-information-container">
                <div className="line-2">
                  {(apptDetail?.clinician_first_name ||
                  apptDetail?.patient_name ||
                  apptDetail?.appointment_patient) && (
                  <>
                   {role == "doctor" ? (
                      <>
                        <div className="name-age-years">
                          {utils.FirstNameLastName(utils.FormatName(utils.getDisplayName(
                            apptDetail?.patient_name ||
                              apptDetail?.appointment_patient, patient_last_name
                          )), "250px")}&nbsp;| {apptDetail?.age} years | {utils.Capitalize(
                            apptDetail?.gender ||
                              apptDetail?.appointment_patient_gender ||
                              "Male"
                          )}
                        </div>
                    </>
                    ) : (
                      <><div className="name">
                      {utils.FirstNameLastName(utils.salutationPrefixName((apptDetail?.salutation || apptDetail?.doctor_salutation), utils.getDisplayName(apptDetail?.clinician_first_name ||apptDetail?.appointment_doctor, doctor_last_name)), "250px")}
                    </div></>
                    )} 
                  </>
                )}
                  <div style={{display:"flex",alignItems:"center", gap: "8px"}}>
                  <Button
                    className="audio-check-btn"
                    icon={<VideoPreview />}
                    disabled={disableVideo}
                    onClick={handleVideo}
                  >
                    {testResults["video"]?.status=="loading"?
                       `${t(CONSTANTS.PREVIEWING, {lng: tgtLang})}`
                      : `${t(CONSTANTS.PREVIEW_VIDEO, {lng: tgtLang})}`}
                  </Button>
                  {testResults["video"]?.status=="success"?<img src={Icons.circle_checked}/>:testResults["video"]?.status=="loading"? <Spin indicator={<LoadingOutlined spin />} size="small" />:testResults["video"]?.status=="error"?<img src={Icons.error_red_circle}/>:<></>}
                  </div>
                </div>
                <div className="line-2">
                  <div className="date-time-container">
                    {utils.FormatDate(
                      apptDetail?.appointment_date_time ||
                        apptDetail?.appointment_date,
                      "DATE_TIME_3"
                    )}
                  </div>
                  <div style={{display:"flex",alignItems:"center", gap: "8px"}}>
                  <Button
                    className="audio-check-btn"
                    style={{alignItems:"baseline"}}
                    icon={<img src={Icons.appointments_modal_mic_icon}/>}
                    onClick={handleAudio}
                    disabled={playingAudio || disableAudio || (listening && !playingAudio)}
                  >
                    {listening && !playingAudio
                      ? `${t(CONSTANTS.SAY_SOMETHING, {lng: tgtLang})}`
                      : `${t(CONSTANTS.CHECK_AUDIO, {lng: tgtLang})}`}
                  </Button>
                  {playingAudio && <SoundFilled className="play-icon" />}
                  {testResults["audio"]?.status=="success"?<img src={Icons.circle_checked}/>:testResults["audio"]?.status=="error"?<img src={Icons.error_red_circle}/>:<></>}
                  {listening && (
                    <div className="timer-container">
                      <div className="timer">
                        <span>{countdown}</span>
                      </div>
                    </div>
                  )}
                  </div>
                </div>
              </div>
             
            </Row>
            <Row>
              <Col span={24}>
                <div id="video-container"></div>
              </Col>
            </Row>

          {/* {Object.entries(testResults).length>0 && 
          <Row
          gutter={8}
          justify="start"
          align="middle"
          className="audio-checking-space"
        >
          {Object.entries(testResults).map(([name, obj], index) => (
            <Col span={8} key={index}>
              <Space size="small">
                <span>{obj.label}</span>
                {obj.status == "success" ? (
                  <CheckCircleOutlined className="success-icon" />
                ) : obj.status == "error" ? (
                  <CloseCircleOutlined className="error-icon" />
                ) : (
                  <Spin size="small" />
                )}
              </Space>
            </Col>
          ))}
        </Row>}  */}
               
                  <Row style={{display:"flex", justifyContent:"center"}} >
                    
                  <CommonButton label={t(CONSTANTS.JOIN_NOW, {lng: tgtLang})}
                   onClick={() => handleTestConnection(false)}
                   disabled={disableActions}
                  className="common-button-green" /></Row>
                  <Row><LinkButton  className="link-button-green"
                    onClick={() => handleTestConnection(true)}
                    disabled={disableActions} label={t(CONSTANTS.TEST_CONNECTION_JOIN, {lng: tgtLang})}/></Row>                 
                {/* </Space> */}
          </Space>
          </div>          
        </div>
      </Modal>
    </>
  );
};
export default memo(AppointmentJoinModal);
